export default {
  tiktok: require('./images/tiktok.png'),
  logo: require('./images/logo.png'),
  imgBackground: require('./images/baner.png'),
  scan: require('./images/scan.png'),
  zalo: require('./images/zalo.png'),
  star: require('./images/star.png'),
  icGoogle: require('./images/ic_google.png'),
  product: require('./images/guide/product.png'),
  customer: require('./images/guide/customer.png'),
  provider: require('./images/guide/provider.png'),
  order: require('./images/guide/order.png'),
  category: require('./images/guide/category.png'),
  success: require('./images/guide/success.png'),
  analytics: require('./images/guide/analytics.png'),
  invoice1: require('./images/invoice/invoice1.png'),
  invoice2: require('./images/invoice/invoice2.png'),
  invoice3: require('./images/invoice/invoice3.png'),
  invoice4: require('./images/invoice/invoice4.png'),
  invoice5: require('./images/invoice/invoice5.png'),
  qr1: require('./images/invoice/qr1.png'),
  qr2: require('./images/invoice/qr2.png'),
  qr3: require('./images/invoice/qr3.png'),
  qr4: require('./images/invoice/qr4.png'),
  intros: [require('./images/intro/intro1.png'), require('./images/intro/intro2.png'), require('./images/intro/intro3.png'), require('./images/intro/intro4.png')]
};
